/*
 * Display helpers for the Direct claims report. Kept apart from the component
 * so the date handling, where the off-by-one-day bugs live, is testable.
 */

const pad = (value: number) => String(value).padStart(2, '0');

// A calendar Date to YYYY-MM-DD in local time. toISOString would shift the
// day for anyone east of UTC before 4am, which is everyone in Dubai.
export function toIsoDate(date: Date | null | undefined): string {
  if (!date) return '';
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function fromIsoDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return null;
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
}

// `YYYY-MM-DD HH:mm:ss` to `DD/MM/YYYY HH:mm`, the format GlobeMed users read.
export function displayDateTime(value: string | null): string {
  if (!value) return '-';
  const match = /^(\d{4})-(\d{2})-(\d{2})(?: (\d{2}:\d{2}))?/.exec(value);
  if (!match) return value;
  const [, year, month, day, time] = match;
  return time ? `${day}/${month}/${year} ${time}` : `${day}/${month}/${year}`;
}

export function statusColor(status: string | null): string {
  switch ((status || '').toLowerCase()) {
    case 'approved':
      return 'success';
    case 'rejected':
      return 'danger';
    case 'partially approved':
      return 'warning';
    default:
      return '';
  }
}
